import { Component } from '@angular/core';
import { MainPage, NavController, ToastController, LocalStorageService, AlertController, App, UserService } from '../mainpage';
import { ContestService } from '../../providers/contest';

@Component({
  selector: 'page-whatsapp',
  templateUrl: 'whatsapp.html'
})

export class  WhatsAppPage extends MainPage {
    constructor(public appCtrl: App, public navCtrl: NavController, protected toastCtrl: ToastController, 
        public localStorageService: LocalStorageService, public contestService: ContestService, 
        protected alertController: AlertController,
        protected userService: UserService) {
        super(navCtrl, toastCtrl, localStorageService, alertController, userService, appCtrl);
    }

    public loadPage(): void {
         
    }

}


// WEBPACK FOOTER //
// ./src/pages/about/whatsapp.ts